class SidebarMenuManager {
  constructor() {
    this.isMobile = false;
    this.init();
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
      this.checkMobileState();
      this.setupSidebarMenus();
      this.setupResizeHandler();
    });
  }

  checkMobileState() {
    this.isMobile = window.innerWidth < 768;
  }

  setupSidebarMenus() {
    if (this.isMobile) {
      this.resetToDefaultMobile();
      return;
    }

    const dropdownMenus = document.querySelectorAll('.main-nav__child:not(.mega-nav)');
    
    dropdownMenus.forEach(dropdown => {
      this.initializeDropdown(dropdown);
    });
  }

  resetToDefaultMobile() {
    const dropdownMenus = document.querySelectorAll('.main-nav__child:not(.mega-nav)');
    
    dropdownMenus.forEach(dropdown => {
      const existingPanel = dropdown.querySelector('.sidebar-submenu-panel');
      if (existingPanel) {
        existingPanel.remove();
      }

      const disclosurePanels = dropdown.querySelectorAll('.disclosure__panel');
      disclosurePanels.forEach(panel => {
        panel.style.display = '';
      });

      const navMenus = dropdown.querySelectorAll('nav-menu details');
      navMenus.forEach(navMenu => {
        navMenu.style.pointerEvents = '';
      });

      this.removeAllActiveStates(dropdown);

      this.removeEventListeners(dropdown);
    });
  }

  initializeDropdown(dropdown) {
    if (this.isMobile) return;

    const existingPanel = dropdown.querySelector('.sidebar-submenu-panel');
    if (existingPanel) {
      existingPanel.remove();
    }

    const rightPanel = this.createRightPanel();
    dropdown.appendChild(rightPanel);
    
    const categoryItems = dropdown.querySelectorAll('.child-nav > li:nth-child(n+3)');
    
    categoryItems.forEach((item, index) => {
      this.setupCategoryItem(item, categoryItems, rightPanel);
    });
    
    this.setupDropdownEvents(dropdown, categoryItems, rightPanel);
  }

  createRightPanel() {
    const rightPanel = document.createElement('div');
    rightPanel.className = 'sidebar-submenu-panel';
    rightPanel.innerHTML = '';
    rightPanel.style.display = 'none';
    return rightPanel;
  }

  setupCategoryItem(item, categoryItems, rightPanel) {
    if (this.isMobile) return;

    const toggle = item.querySelector('.child-nav__item--toggle');
    const navMenu = item.querySelector('nav-menu');
    const panel = navMenu ? navMenu.querySelector('.disclosure__panel') : null;
    
    if (toggle) {
      toggle.removeEventListener('mouseenter', this.handleCategoryHoverBound);
      toggle.removeEventListener('click', this.handleCategoryClickBound);
      
      this.handleCategoryHoverBound = () => {
        this.handleCategoryHover(toggle, categoryItems, panel, rightPanel);
      };
      
      this.handleCategoryClickBound = (e) => {
        this.handleCategoryClick(e, toggle, rightPanel);
      };
      
      toggle.addEventListener('mouseenter', this.handleCategoryHoverBound);
      toggle.addEventListener('click', this.handleCategoryClickBound);
    }
  }

  handleCategoryHover(targetElement, categoryItems, panel, rightPanel) {
    if (this.isMobile) return;

    this.removeActiveStates(categoryItems);

    targetElement.classList.add('active');
    
    this.updateRightPanel(panel, targetElement, rightPanel);
  }

  handleCategoryClick(e, targetElement, rightPanel) {
    if (this.isMobile) return;
    
    const categoryLink = targetElement.getAttribute('data-category-url');
    
    if (categoryLink) {
      if (targetElement.classList.contains('child-nav__item--toggle')) {
        e.preventDefault();
      }
      window.location.href = categoryLink;
    }
  }

  updateRightPanel(panel, targetElement, rightPanel) {
    const hasContent = panel && 
                      panel.innerHTML.trim() && 
                      panel.querySelector('.main-nav__grandchild') && 
                      panel.querySelector('.main-nav__grandchild').children.length > 0;
    
    if (hasContent) {
      rightPanel.style.display = 'flex';
      rightPanel.innerHTML = panel.innerHTML;
      
      const grandchildList = rightPanel.querySelector('.main-nav__grandchild');
      if (grandchildList) {
        this.setupGrandchildList(grandchildList);
      }
    } else {
      rightPanel.style.display = 'none';
      rightPanel.innerHTML = '';
    }
  }

  setupGrandchildList(grandchildList) {
    // Subcategory list if you need
  }

  // Reset when mouseleave
  setupDropdownEvents(dropdown, categoryItems, rightPanel) {
    if (this.isMobile) return;

    dropdown.removeEventListener('mouseleave', this.dropdownMouseLeaveBound);
    rightPanel.removeEventListener('mouseleave', this.rightPanelMouseLeaveBound);

    this.dropdownMouseLeaveBound = () => {
      this.resetActiveStates(categoryItems, rightPanel);
    };

    this.rightPanelMouseLeaveBound = (e) => {
      if (!dropdown.contains(e.relatedTarget)) {
        this.resetActiveStates(categoryItems, rightPanel);
      }
    };

    dropdown.addEventListener('mouseleave', this.dropdownMouseLeaveBound);
    rightPanel.addEventListener('mouseleave', this.rightPanelMouseLeaveBound);
  }

  removeActiveStates(categoryItems) {
    categoryItems.forEach(item => {
      const target = item.querySelector('.child-nav__item--toggle') || 
                    item.querySelector('.child-nav__item');
      if (target) {
        target.classList.remove('active');
      }
    });
  }

  removeAllActiveStates(dropdown) {
    const allActiveElements = dropdown.querySelectorAll('.active');
    allActiveElements.forEach(element => {
      element.classList.remove('active');
    });
  }

  removeEventListeners(dropdown) {
    const categoryItems = dropdown.querySelectorAll('.child-nav > li:nth-child(n+3)');
    categoryItems.forEach(item => {
      const toggle = item.querySelector('.child-nav__item--toggle');
      if (toggle) {
        if (this.handleCategoryHoverBound) {
          toggle.removeEventListener('mouseenter', this.handleCategoryHoverBound);
        }
        if (this.handleCategoryClickBound) {
          toggle.removeEventListener('click', this.handleCategoryClickBound);
        }
      }
    });

    if (this.dropdownMouseLeaveBound) {
      dropdown.removeEventListener('mouseleave', this.dropdownMouseLeaveBound);
    }

    const rightPanel = dropdown.querySelector('.sidebar-submenu-panel');
    if (rightPanel && this.rightPanelMouseLeaveBound) {
      rightPanel.removeEventListener('mouseleave', this.rightPanelMouseLeaveBound);
    }
  }

  resetActiveStates(categoryItems, rightPanel) {
    this.removeActiveStates(categoryItems);
    rightPanel.style.display = 'none';
    rightPanel.innerHTML = '';
  }

  setupResizeHandler() {
    const handleResize = this.debounce(() => {
      const wasMobile = this.isMobile;
      this.checkMobileState();
      
      if (wasMobile !== this.isMobile) {
        this.setupSidebarMenus();
      }
    }, 250);
    
    window.addEventListener('resize', handleResize);
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  getCategoryName(targetElement) {
    const categoryLink = targetElement.querySelector('a') || targetElement;
    return categoryLink.textContent.trim().replace('›', '').replace(/\s+/g, ' ');
  }
}

new SidebarMenuManager();